export default __webpack_public_path__ + "static/media/ic-check-mark-x.531745eb.png";